/* eslint-disable react/no-array-index-key */
import { DimensionInput } from 'TypeDefs/Objectives'
import { Dispatch, SetStateAction } from 'react'
import { Tooltip, Typography } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'
import { MAX_DIMENSIONS, hasDuplicates } from 'TypeDefs/Categories'
import { GoalToDimension } from 'Generated/graphql-types'
import {
  List,
  Container,
  ErrorMessage,
  InfoMessage,
} from './DimensionList.styles'
import DimensionItem from './DimensionItem'

const DUPLICATE_ERROR = 'Dimensions must have unique names.'

type DimensionListProps = {
  displayStartValue?: boolean
  dimensionInfo: DimensionInput[]
  setDimensionInfo: Dispatch<SetStateAction<DimensionInput[]>>
  isEditable?: boolean
  allDimensions?: GoalToDimension[]
  handleDeleteCategoryArray?: (goalToDimensionId: number) => void
  isEditForm?: boolean
  initiativeId?: number | null
  goalId?: number | null
}

const DimensionList = ({
  dimensionInfo,
  setDimensionInfo,
  displayStartValue = false,
  isEditable,
  allDimensions,
  handleDeleteCategoryArray,
  isEditForm,
  initiativeId,
  goalId,
}: DimensionListProps) => {
  // Find the dimension ID based on its title
  const findDimensionIdByTitle = (title: string) => {
    const matchingDimension = allDimensions?.find(
      (dimension) => dimension.dimension.title === title
    )
    return matchingDimension ? matchingDimension.id : null
  }

  // Retrieve dimension IDs associated with a specific goal
  const getDimensionIdForGoal = dimensionInfo.map((dim) =>
    findDimensionIdByTitle(dim.title)
  )
  return (
    <Container>
      <List>
        {dimensionInfo.map((dim, index) => {
          const goalToDimensionId = getDimensionIdForGoal[index]

          return (
            <DimensionItem
              key={index}
              index={index}
              dimensionInfo={dimensionInfo}
              setDimensionInfo={setDimensionInfo}
              displayStartValue={displayStartValue}
              isEditable={isEditable}
              goalToDimensionId={goalToDimensionId}
              handleDeleteCategoryArray={handleDeleteCategoryArray}
              isEditForm={isEditForm}
              initiativeId={initiativeId}
              goalId={goalId}
            />
          )
        })}
      </List>
      {hasDuplicates(dimensionInfo) && (
        <ErrorMessage>{DUPLICATE_ERROR}</ErrorMessage>
      )}
      {dimensionInfo.length === MAX_DIMENSIONS && (
        <InfoMessage>
          You’ve reached the max number of dimensions per goal.
          <Tooltip
            interactive
            placement='top-end'
            title={
              <Typography color='inherit'>
                Fewer dimensions on one goal keep your chart readable and
                emphasize the important takeaways. If you need more than six
                dimensions, try grouping them or using another chart.
              </Typography>
            }
          >
            <InfoIcon />
          </Tooltip>
        </InfoMessage>
      )}
    </Container>
  )
}

export default DimensionList

DimensionList.defaultProps = {
  displayStartValue: false,
  isEditable: false,
  allDimensions: null,
  handleDeleteCategoryArray: null,
  isEditForm: false,
  initiativeId: null,
  goalId: null,
}
